import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgNote = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M0 .279c4.623 0 10.953-.235 15.498-.117c6.099.156 8.39 2.813 8.468 9.374c.077 3.71 0 14.335 0 14.335h-6.598c0-9.296.04-10.83 0-13.759c-.078-2.578-.814-3.807-2.795-4.041c-2.097-.235-7.975-.04-7.975-.04v17.84H0Z"
	})
});
export default SvgNote;
